
import React from 'react';
import { Text } from 'theme-ui';
import { useTranslate } from '~/hooks/utils/use-translate';

type Props = {
  error: any;
};

const ValidationError = ({ error }: Props) => {
  const translate = useTranslate();

  if (!error || !Object.values(error).filter(Boolean).length) return null;

  const getValidationMessage = () => {
    if (typeof error === 'string') return error;
    if (error.message) return error.message;
    switch (error.type) {
      case 'required':
        return translate('validation.required_field');
      case 'pattern':
        return translate('validation.invalid_email');
      default:
        return translate('error.api.default');
    }
  };
  return (
    <Text
      variant="formError"
      sx={{
        mt: '.4rem',
        width: '100%',
        mx: 'auto',
      }}
    >
      {getValidationMessage()}
    </Text>
  );
};

export default ValidationError;
